export default {
    minimumLengthOfSearch: 3
}